import { useState, useEffect, useRef } from "react";
import { withRouter } from "react-router-dom";
import { useSnackbar } from "notistack";
import { Table, TableBody, Paper, Grid } from "@material-ui/core";
import moment from "moment";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { HtTaskForm, HtList } from "../components";
import HtHd from "../components/HtHd";
import BasicDetailHeader from "../../BasicDetailHeader";
import { EmptyCollection, PageLoader, AccessDenied, DeletePopUp } from "../../../../shared_elements";
import { permissionCheckFnforCamo, downloadFileType } from "../../../../utils";
import { globalGetService, globalDeleteService, globalExportService } from "../../../../utils/globalApiServices";
import { trackActivity } from "../../../../utils/mixpanel";
import SubDetails from "../../../../shared_elements/components/sub_details/SubDetails";
import Pagination from "../../../../shared_elements/components/Pagination";
import ImportFileModule from "../../../../shared_elements/components/import_Format/ImportFileModule";
import CtaAction from "../../../../shared_elements/components/cta/CtaAction";
const HardTime = ({ match }) => {
	const { enqueueSnackbar } = useSnackbar();

	const [pageLoader, setPageLoader] = useState(false);
	const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
	const [filter, setFilter] = useState({});
	const [data, setData] = useState({ list: [], pagination: {}, new_task_last_used_folder_uuid: '', last_used_folder_uuid_link_document: '', checkbox_last_used_folder_uuid: '', checkbox_last_used_folder_name: '', });
	const [htCRU, setHtCRU] = useState({ modal: false, data: null, mode: '' });
	const [deleteList, setDeleteList] = useState({ modal: false, data: null });
	const [importFiles, setImportFiles] = useState({ modal: false });
	const [headerInfo, setHeaderInfo] = useState({ tsn: '', csn: '', dom: '', slug: '' });
	const [uuid, setUuid] = useState('');
	const [isBasicDetailExpanded, setIsBasicDetailExpanded] = useState(true);
	const [basicDetails, setBasicDetails] = useState({});
	const currentPerPageRef = useRef(250);

	useEffect(() => {
		trackActivity('CAMO', { event_type: 'Page Visited', page_title: 'Hard Time(HT)' });
		getHtList({ per_page: 250 });
	}, []);

	const getHtList = (queryParams = {}, searchString = null) => {
		if (!permissionCheckFnforCamo({ primaryKey: "ht_component", keyIndex: "R" })) return;
		setPageLoader(true);
		const { asset, assetType: assetTypeParam } = match.params;
		globalGetService('camo/ht/list/', {
			...queryParams,
			per_page: queryParams.per_page || currentPerPageRef.current,
			asset,
			asset_type: assetTypeParam,
			search: searchString,
		}).then((response) => {
			setPageLoader(false);
			if (response.status === 500) {
				enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
				return;
			}
			const { results, pagination } = response.data;
			const cleanFilter = { ...queryParams };
			delete cleanFilter.page;
			delete cleanFilter.per_page;
			delete cleanFilter.asset_type;
			delete cleanFilter.sort;
			delete cleanFilter.sort_by;
			setFilter(cleanFilter);
			setData(prev => ({
				...prev,
				list: results,
				pagination: {
					...prev.pagination,
					total: pagination.total,
					per_page: pagination.per_page,
					page: parseInt(pagination.current_page),
				},
				new_task_last_used_folder_uuid: response.data.new_task_last_used_folder_uuid,
				last_used_folder_uuid_link_document: response.data.last_used_folder_uuid_link_document,
				checkbox_last_used_folder_uuid: response.data.checkbox_last_used_folder_uuid,
				checkbox_last_used_folder_name: response.data.checkbox_last_used_folder_name,
			}));
		});
	};

	const createSortHandler = (sortField) => {
		const newSortBy = sortField === sortInfo.sort ? (sortInfo.sort_by === 'asc' ? 'desc' : 'asc') : 'asc';
		const newSortInfo = { sort: sortField, sort_by: newSortBy };
		setSortInfo(newSortInfo);
		getHtList({ ...filter, ...newSortInfo, page: 1, per_page: data?.pagination?.per_page });
	};

	const deleteHtRecord = () => {
		setPageLoader(true);
		globalDeleteService(`camo/ht/${deleteList.data.id}/delete/`).then((response) => {
			setPageLoader(false);
			setDeleteList({ modal: false, data: null });
			if (response.status === 200) {
				enqueueSnackbar("Record Deleted Successfully", { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
				trackActivity('CAMO', { event_type: 'Item Deleted', page_title: 'Hard Time(HT)', item_id: deleteList.data?.id });
			} else if (response.status === 500) {
				enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
			}
			getHtList({ per_page: currentPerPageRef.current });
		});
	};

	const exportHtList = (extension) => {
		setPageLoader(true);
		const todayDate = moment(new Date()).format("YYYY-MM-DD");
		const { asset, assetType: assetTypeParam } = match.params;
		const exportUrl = assetTypeParam == 2
			? `/camo/ht/engine/${asset}/${assetTypeParam}/export/`
			: `/camo/ht/${asset}/${assetTypeParam}/export/`;
		globalExportService(exportUrl, { download: extension }).then((response) => {
			setPageLoader(false);
			if (response.status === 500) {
				enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
			} else {
				downloadFileType(response.data, `${todayDate}_ESN ${basicDetails?.esn || basicDetails?.msn}_HT`, extension);
				enqueueSnackbar("Download of HT List successful", { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
				trackActivity("CAMO", { event_type: "Item Exported", page_title: "Hard Time(HT)", extension });
			}
		});
	};

	const downloadSampleFile = (extension) => {
		setPageLoader(true);
		const { assetType: assetTypeParam } = match.params;
		globalExportService(`camo/ht/sample-file/${assetTypeParam}/`).then((response) => {
			setPageLoader(false);
			if (response.status === 500) {
				enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
			} else {
				downloadFileType(response.data, 'SampleFile_HT', extension);
				trackActivity("CAMO", { event_type: 'Sample File Downloaded', page_title: "Hard Time(HT)", extension });
			}
		});
	};

	const downloadAllFiles = async (queryParams = {}) => {
		setPageLoader(true);
		const attachment_list = queryParams.item.download_attachments.map((entry) => [entry[0], decodeURIComponent(entry[1])]);
		const zip = new JSZip();
		const folder = zip.folder('DownloadedFiles');
		try {
			const downloadPromises = attachment_list.map(async (entry) => {
				const res = await fetch(entry[1] || '');
				if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
				const blob = await res.blob();
				folder.file(entry[0], blob);
			});
			await Promise.all(downloadPromises);
			const content = await zip.generateAsync({ type: 'blob' });
			saveAs(content, 'HT.zip');
			setPageLoader(false);
		} catch (error) {
			console.error('Error:', error);
			setPageLoader(false);
		}
	};

	const pullData = (slug, tsn, csn, dom) => {
		setHeaderInfo({ slug, tsn, csn, dom });
	};

	const uuidData = (uuidVal) => setUuid(uuidVal);

	return (
		<section className="ht-page">
			{pageLoader ? <PageLoader /> : null}
			<Grid style={{ marginTop: 0 }} spacing={3} container>
				<Grid style={{ paddingTop: 0, paddingRight: 0 }} xs={12} item>
					<SubDetails
						masterExport={false}
						title="Hard Time Components"
						slug={headerInfo.slug}
						match={match}
						onRefresh={() => getHtList({ per_page: currentPerPageRef.current })}
						permissionCheck={permissionCheckFnforCamo({ primaryKey: "ht_component", keyIndex: "U" })}
					/>
					<BasicDetailHeader props={match} func={pullData} uuid={uuidData} module="ht" engineType={(data) => setBasicDetails(data)} onAccordionChange={setIsBasicDetailExpanded} />
					{permissionCheckFnforCamo({ primaryKey: "ht_component", keyIndex: "R" }) ? (
						<Paper square style={{ padding: "5px", marginTop: "10px" }} variant="outlined">
							<CtaAction
								searchPlaceholder="Search ATA Chapter, Part Description, Part Number, Part Serial Number"
								onSearch={(value) => getHtList({ per_page: currentPerPageRef.current }, value)}
								permissionCheck={!permissionCheckFnforCamo({ primaryKey: "ht_component", keyIndex: "C" }) || window?.location?.search.includes('archived-assets')}
								addLabel="HT COMPONENTS"
								onAddFn={() => setHtCRU({ modal: true, data: null, mode: 'add' })}
								onImportFn={() => setImportFiles({ modal: true })}
								exportMenu={{
									exportReportFn: (file) => exportHtList(file?.extension),
									files: [{ title: 'EXCEL', extension: 'xlsx' }, { title: 'PDF', extension: 'pdf' }],
									disabled: !data?.list?.length,
								}}
								downloadSampleMenu={{
									exportReportFn: (file) => downloadSampleFile(file?.extension),
									files: [{ title: 'DOWNLOAD SAMPLE', extension: 'xlsx', type: 'sample' }],
								}}
							/>
							<div style={{ height: `${window.innerHeight - (isBasicDetailExpanded ? 430 : 295)}px`, overflow: 'auto' }}>
								<Table className="mui-table-format" stickyHeader={true}>
									<HtHd
										sortInfo={sortInfo}
										createSortHandler={createSortHandler}
									/>
									<TableBody>
										{data?.list?.map((item, index) => (
											<HtList
												key={index}
												item={item}
												getResponseBack={() => getHtList({ per_page: currentPerPageRef.current })}
												toggleModalFn={() => setHtCRU({ modal: true, data: item, mode: 'edit' })}
												toggleDelteModalFn={() => setDeleteList({ modal: true, data: item })}
												downloadAllApi={() => downloadAllFiles({ item })}
											/>
										))}
									</TableBody>
								</Table>
								{!data?.list?.length ? <EmptyCollection title="No Records Found" /> : null}
							</div>
							<Pagination
								pagination={data?.pagination}
								onChangeRowsPerPage={(e) => {
									currentPerPageRef.current = e.target.value;
									getHtList({ page: 1, per_page: e.target.value });
								}}
								onChangePage={(event, newPage) => getHtList({ per_page: data.pagination.per_page, page: newPage + 1 })}
							/>
						</Paper>
					) : (
						<AccessDenied />
					)}
				</Grid>
			</Grid>

			{htCRU?.modal ? (
				<HtTaskForm
					modeType={htCRU.mode}
					htData={htCRU.data}
					modalCloseFn={() => setHtCRU({ modal: false, data: null, mode: '' })}
					getResponseBack={() => getHtList({ per_page: currentPerPageRef.current })}
					headerTsn={headerInfo.tsn}
					headerCsn={headerInfo.csn}
					uuid={uuid}
					last_used_folder_uuid={data.new_task_last_used_folder_uuid}
					last_used_folder_uuid_link_document={data.last_used_folder_uuid_link_document}
					checkbox_last_used_folder_uuid={data.checkbox_last_used_folder_uuid}
					checkbox_last_used_folder_name={data.checkbox_last_used_folder_name}
				/>
			) : null}

			{deleteList?.modal ? (
				<DeletePopUp
					title="Delete HT Record"
					deleteRecordFn={deleteHtRecord}
					modal={true}
					content="Do you really want to delete this record?"
					toggleModalFn={() => setDeleteList({ modal: false, data: null })}
				/>
			) : null}

			{importFiles?.modal ? (
				<ImportFileModule
					importUrl={`camo/ht/${match?.params?.asset}/${match?.params?.assetType}/import/`}
					title="Import Hard Time Components"
					getResponseBack={() => getHtList({ per_page: currentPerPageRef.current })}
					toggleModalFn={() => setImportFiles({ modal: false })}
				/>
			) : null}
		</section>
	);
};

export default withRouter(HardTime);
